import {
  httpGet, httpPost, httpPut, httpDelete,
} from '../httpCalls';
import {
  resetListTable,
  reloadListTable,
  updateRowTable,
  createListTableElement,
  removeListTableElement,
  updateItemListTable,
  updateAttributeOfItems,
} from '../../actions/listTableActions';
import { reloadError } from '../../actions/errorActions';
import { createSession } from '../../actions/sessionActions';
import { mapPagination } from './maps';

let abortController;
/* eslint-disable import/prefer-default-export */

export const getItems = (url, dispatch) => {
  dispatch(resetListTable());
  return httpGet(url).then((valuesRequest) => {
    const values = mapPagination(valuesRequest);
    dispatch(reloadListTable(values));
  });
};
// eslint-disable-next-line max-len
export const getItemsWithoutPagination = (url) => httpGet(url).then((valuesRequest) => valuesRequest);

export const getSearchedItems = (url, dispatch) => {
  if (abortController) {
    abortController.abort();
  }
  abortController = new AbortController();
  return httpGet(url, process.env.REACT_APP_API_ENDPOINT, abortController.signal)
    .then((valuesRequest) => {
      const values = mapPagination(valuesRequest);
      dispatch(reloadListTable(values));
    }).catch(() => {
      // To catch abort errors, not remove!
    });
};

export const getSortedItems = (url, dispatch) => httpGet(url).then((valuesRequest) => {
  const values = mapPagination(valuesRequest);
  dispatch(reloadListTable(values));
});

export const createItem = (url, item, dispatch, loadPage) => httpPost(url, item).then((newItem) => {
  if(loadPage){
    getItems(loadPage, dispatch);
  }else{
    dispatch(createListTableElement(newItem));
  }
}, (error) => {
  dispatch(reloadError(error));
  return Promise.reject(error);
});

export const updateItem = (url, item, dispatch) => httpPut(url, item).then(() => {
}, (error) => {
  dispatch(reloadError(error));
  return Promise.reject(error);
});
export const updateRowItems = (url,
  items,dispatch)=>httpPut(url,items).then((result)=>{
    dispatch(updateRowTable(result));
  },(error)=>{
    dispatch(reloadError(error));
    return Promise.reject(error);

});

export const updateItems = (url,
  items,
  dispatch,
  attributesToUpdate) => httpPut(url, items).then((result) => {
  if (attributesToUpdate) dispatch(updateAttributeOfItems(result, attributesToUpdate));
}, (error) => {
  dispatch(reloadError(error));
  return Promise.reject(error);
});

export const updateLocalItem = (item, dispatch) => {
  dispatch(updateItemListTable(item));
};

export const removeItem = (url, item, dispatch) => httpDelete(`${url}/${item.id}`).then(() => {
  dispatch(removeListTableElement(item));
}, (error) => {
  dispatch(reloadError(error));
  return Promise.reject(error);
});

export const bulk = (url, payload, dispatch) => httpPost(`${url}/bulk`, payload).then((response) => {
  return Promise.resolve(response);
}, (error) => {
  dispatch(reloadError(error));
  return Promise.reject(error);
});

export const resetList = (dispatch) => dispatch(resetListTable());

// eslint-disable-next-line max-len
export const tableEdited = (dispatch, value = true) => dispatch(createSession({ isBlocking: value }));

export const getCatalog = (api) => httpGet(`${api}`).then((valuesRequest) => mapPagination(valuesRequest));
